import { render, staticRenderFns } from "./GoodPhoto2.vue?vue&type=template&id=22392d90&scoped=true"
import script from "./GoodPhoto2.vue?vue&type=script&lang=js"
export * from "./GoodPhoto2.vue?vue&type=script&lang=js"
import style0 from "./GoodPhoto2.vue?vue&type=style&index=0&id=22392d90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22392d90",
  null
  
)

export default component.exports